<section class="mapping-dialog">
  <header class="mapping-dialog__header">
    <h2>Добавить привязку к бренду</h2>
    <p *ngIf="brand">
      Вы добавляете ещё одно название для бренда
      <strong>#{{ brand.id }} {{ brand.description }}</strong>.
    </p>
  </header>

  <div class="mapping-dialog__howto">
    <div class="mapping-dialog__step">
      <span class="mapping-dialog__step-number">1</span>
      <span>Введите название, которое должно считаться этим брендом.</span>
    </div>
    <div class="mapping-dialog__step">
      <span class="mapping-dialog__step-number">2</span>
      <span>Если название свободно, оно просто сохранится как привязка.</span>
    </div>
    <div class="mapping-dialog__step">
      <span class="mapping-dialog__step-number">3</span>
      <span>Если название уже занято другим брендом, ниже появится понятный блок со слиянием.</span>
    </div>
  </div>

  <form class="mapping-dialog__form" (ngSubmit)="save()">
    <mat-form-field appearance="outline">
      <mat-label>Название</mat-label>
      <input
        matInput
        type="text"
        [formControl]="descriptionControl"
        placeholder="Например: HYUNDAI (BEIJING)"
        [disabled]="loading"
      />
    </mat-form-field>

    <div class="mapping-dialog__actions">
      <button mat-flat-button color="primary" type="submit" [disabled]="loading">
        {{ loading ? 'Проверяем...' : 'Проверить и сохранить' }}
      </button>
    </div>
  </form>

  <section class="occupied-brand" *ngIf="occupiedBrandConflict">
    <div class="occupied-brand__title">Это название уже занято другим брендом</div>
    <div class="occupied-brand__message">
      <strong>{{ occupiedBrandConflict.description }}</strong>
      уже существует как отдельный бренд. Поэтому название нельзя просто добавить к текущему бренду.
    </div>

    <div class="occupied-brand__panel">
      <div class="occupied-brand__column">
        <div class="occupied-brand__label">Текущий бренд</div>
        <div class="occupied-brand__value" *ngIf="brand">
          #{{ brand.id }} {{ brand.description }}
        </div>
      </div>

      <div class="occupied-brand__arrow">→</div>

      <div class="occupied-brand__column">
        <div class="occupied-brand__label">Бренд, который будет слит</div>
        <div class="occupied-brand__value">
          #{{ occupiedBrandConflict.id }} {{ occupiedBrandConflict.description }}
        </div>
        <div class="occupied-brand__meta" *ngIf="occupiedBrandConflict.shortDescription">
          Короткое имя: {{ occupiedBrandConflict.shortDescription }}
        </div>
        <div class="occupied-brand__meta">
          Товаров: {{ occupiedBrandConflict.productCount }}
        </div>
      </div>
    </div>

    <div class="occupied-brand__explain">
      Если нажать кнопку ниже, бренд
      <strong>{{ occupiedBrandConflict.description }}</strong>
      будет слит в
      <strong>{{ brand?.description }}</strong>,
      а это название останется как привязка у текущего бренда.
    </div>

    <div class="occupied-brand__actions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="mergeConflictingBrand()"
        [disabled]="loading"
      >
        Слить этот бренд в текущий
      </button>
    </div>
  </section>
</section>
